import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { StackedBarComponent, StackedBarSegment } from '../../components/stacked-bar/stacked-bar.component';
import { SectionTitleComponent } from '../../../components/section-title/section-title.component';
import { ProjectProgress } from '../../models/dashboard.model';
import { projectColorVar } from '../../models/project-colors';

interface LegendItem {
  key: string;
  colorVar: string;
  count: number;
}

interface ProjectRow {
  projectId: string;
  name: string;
  colorVar: string;
  passRate: number;
  total: number;
  projectLink: unknown[];
  segments: StackedBarSegment[];
  barAriaParams: Record<string, string | number>;
  legend: LegendItem[];
}

@Component({
  selector: 'app-test-progress',
  imports: [RouterLink, TranslatePipe, MatIcon, StackedBarComponent, SectionTitleComponent],
  templateUrl: './test-progress.component.html',
  styleUrl: './test-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestProgressComponent {
  projects = input.required<ProjectProgress[]>();
  colorOrder = input<readonly string[]>([]);

  protected readonly headingId = 'test-progress-heading';

  protected readonly rows = computed<ProjectRow[]>(() =>
    this.projects().map((project, index) => ({
      projectId: project.projectId,
      name: project.name,
      colorVar: projectColorVar(project.projectId, this.colorOrder(), index),
      passRate: project.total > 0 ? Math.round((project.passed / project.total) * 100) : 0,
      total: project.total,
      projectLink: ['/projects', project.projectId, 'release'],
      segments: [
        { label: 'passed', value: project.passed, colorVar: '--to-chart-passed' },
        { label: 'failed', value: project.failed, colorVar: '--to-chart-failed' },
        { label: 'blocked', value: project.blocked, colorVar: '--to-warn-dot' },
        { label: 'running', value: project.running, colorVar: '--to-chart-running' },
        { label: 'skipped', value: project.skipped, colorVar: '--to-chart-skipped' },
      ],
      barAriaParams: {
        name: project.name,
        passed: project.passed,
        failed: project.failed,
        blocked: project.blocked,
        running: project.running,
        skipped: project.skipped,
      },
      legend: [
        { key: 'passed', colorVar: '--to-chart-passed', count: project.passed },
        { key: 'failed', colorVar: '--to-chart-failed', count: project.failed },
        { key: 'blocked', colorVar: '--to-warn-dot', count: project.blocked },
        { key: 'running', colorVar: '--to-chart-running', count: project.running },
        { key: 'skipped', colorVar: '--to-chart-skipped', count: project.skipped },
      ],
    })),
  );
}
